import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { AppLayoutComponent } from './layout/app.layout.component';
import { authGuard } from './core/guard/auth.guard';
import { superAdminGuard } from './core/guard/super-admin.guard';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          canActivate: [authGuard],
          children: [
            {
              path: '',
              loadChildren: () => import('./components/dashboard/dashboard.module').then((m) => m.DashboardModule),
            },
            {
              path: 'user',
              loadChildren: () => import('./components/user/user.module').then((m) => m.UserModule),
              canActivate: [superAdminGuard],
            },
            {
              path: 'customer',
              loadChildren: () => import('./components/customer/customer.module').then((m) => m.CustomerModule),
              canActivate: [superAdminGuard],
            },
            {
              path: 'dish',
              loadChildren: () => import('./components/dish/dish.module').then((m) => m.DishModule),
            },
            {
              path: 'category',
              loadChildren: () => import('./components/category/category.module').then((m) => m.CategoryModule),
            },
            {
              path: 'store',
              loadChildren: () => import('./components/store/store.module').then((m) => m.StoreModule),
            },

            {
              path: 'inventory-item',
              loadChildren: () =>
                import('./components/inventory-item/inventory-item.module').then((m) => m.InventoryItemModule),
            },
            {
              path: 'store-inventory',
              loadChildren: () =>
                import('./components/store-inventory/store-inventory.module').then((m) => m.StoreInventoryModule),
            },

            {
              path: 'menu-item',
              loadChildren: () => import('./components/menu-item/menu-item.module').then((m) => m.MenuItemModule),
            },
            {
              path: 'loyalty-coupon',
              loadChildren: () =>
                import('./components/loyalty-coupon/loyalty-coupon.module').then((m) => m.LoyaltyCouponModule),
            },
            {
              path: 'loyalty-program',
              loadChildren: () =>
                import('./components/loyalty-program/loyalty-program.module').then((m) => m.LoyaltyProgramModule),
            },
            {
              path: 'order',
              loadChildren: () => import('./components/order/order.module').then((m) => m.OrderModule),
            },
            {
              path: 'raw-material',
              loadChildren: () =>
                import('./components/raw-material/raw-material.module').then((m) => m.RawMaterialModule),
            },
            {
              path: 'notifications',
              loadChildren: () =>
                import('./components/notification/notification.module').then((m) => m.NotificationModule),
            },
            {
              path: 'utilities',
              loadChildren: () => import('./components/utilities/utilities.module').then((m) => m.UtilitiesModule),
            },
            {
              path: 'blocks',
              loadChildren: () =>
                import('./components/primeblocks/primeblocks.module').then((m) => m.PrimeBlocksModule),
            },
            {
              path: 'pages',
              loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
            },
            // {
            //   path: 'uikit',
            //   loadChildren: () => import('./components/uikit/uikit.module').then((m) => m.UIkitModule),
            // },
          ],
        },
        {
          path: 'landing',
          loadChildren: () => import('./components/landing/landing.module').then((m) => m.LandingModule),
        },
        {
          path: 'auth',
          loadChildren: () => import('./components/auth/auth.module').then((m) => m.AuthModule),
          canActivate: [authGuard],
        },
        { path: 'notfound', component: NotfoundComponent },
        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
